import React from 'react';
import SvgIcon from './SvgIcon';
function DownRectFill(_a) {
    var className = _a.className;
    return (React.createElement(SvgIcon, { className: className },
        React.createElement("svg", { width: "2.8889em", height: "1em", viewBox: "0 0 52 18", fill: "none" },
            React.createElement("rect", { width: "52", height: "17.6129", rx: "8.80645", fill: "var(--down-rect-bg, rgba(0, 0, 0, 0.75))" }),
            React.createElement("path", { d: "M25.998 12.5825C25.7783 12.5825 25.5626 12.508 25.3861 12.359L19.636 7.56588C19.228 7.22856 19.1731 6.62452 19.5144 6.21659C19.8517 5.80867 20.4557 5.75376 20.8637 6.095L26.0098 10.3821L31.148 6.24797C31.5599 5.91457 32.1639 5.98125 32.4934 6.3931C32.8268 6.80495 32.7601 7.40898 32.3483 7.73846L26.5981 12.3707C26.4216 12.5119 26.2098 12.5825 25.998 12.5825Z", fill: "var(--down-rect-arrow, #fff)" }))));
}
export default DownRectFill;
